/**
 * @desc 删除管理域
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** 主键id */
  id?: number;
  /** 管理域id */
  orgId?: string;
}

export function request(params: Params): Promise<defs.StandardReturn<void>> {
  return defHttp.get({
    url: '/web/base/remove',

    params,
  });
}

export function mock(params: Params): Promise<defs.StandardReturn<void>> {
  return defHttp.get({
    url: '/mock/web/base/remove',

    params,
  });
}
